const extTable = {
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/gif': 'gif',
    'image/svg+xml': 'svg',
    'image/svg': 'svg',
};

export const getExtension = (mimeType) => {
    if (mimeType && extTable[mimeType]) {
        return extTable[mimeType];
    } else {
        return false;
    }
};